AVADA_SC.campaigns = [];
AVADA_SC.settings = {
    "id": "qKBEnbJaOx7u7NrQwGF6",
    "hideText": true,
    "modalTop": 18,
    "disableWatermark": false,
    "shopDomain": "loop-generation.myshopify.com",
    "inlinePosition": "before",
    "showMobile": true,
    "modalBorderRadius": 10,
    "displayType": "float-button",
    "modalPosition": "modal-center",
    "tableHoverColor": "#FFFFFF",
    "enableGa": false,
    "modalTextColor": "#232323",
    "linkIcon": "",
    "collectionPagePosition": "",
    "buttonHeight": 35,
    "linkTextColor": "#232323",
    "position": "",
    "tableAnimation": true,
    "modalBgColor": "#FFFFFF",
    "hasCustomCss": true,
    "buttonBorderRadius": 10,
    "modalOverlayColor": "#7b7b7b",
    "buttonRotation": true,
    "modalShadow": true,
    "customIcon": false,
    "linkBgColor": "#FFFFFF",
    "homePagePosition": "",
    "mobilePosition": "top",
    "modalWidth": 84,
    "customCss": "",
    "modalHeight": 64,
    "createdAt": {"_seconds": 1629587990, "_nanoseconds": 515000000},
    "homePageInlinePosition": "before",
    "collectionPageInlinePosition": "before",
    "shopId": "d9Mzs76lQtLVnZakrHUf",
    "modalHeader": "Size guides",
    "linkText": "Size chart",
    "modalLeft": 8,
    "buttonPosition": "middle-right",
    "buttonWidth": 80
}
        